import React from "react";
import { Box, Typography } from "@mui/material";
import { ReactComponent as AlertInfo } from "../assets/svg/AlertInfo.svg";

type Props = {
  name: string;
  value: string;
  warning: {
    message: string;
    type: "danger" | "warning" | "info";
  };
};

export const WarningTelemetry = ({ name, value, warning }: Props) => {
  const getColour = (type: "danger" | "warning" | "info") => {
    switch (type) {
      case "danger":
        return "#ED0505";
      case "warning":
        return "#FFB800";
      case "info":
        return "#6E7191";
    }
  };

  return (
    <Box
      sx={{
        display: "flex",
        justifyContent: "space-between",
        alignItems: "center",
        height: 24,
        py: 0.5,
      }}
    >
      <Box display={"flex"} sx={{ flexDirection: "row" }}>
        <Box sx={{ width: 89 }}>
          <Typography
            textAlign={"start"}
            variant="body1"
            sx={{ color: "primary", fontWeight: 400 }}
          >
            {name}
          </Typography>
        </Box>
        <Box>
          <Typography
            textAlign={"start"}
            variant="body1"
            sx={{ color: "primary", fontWeight: 700 }}
          >
            {value}
          </Typography>
        </Box>
      </Box>
      <Box sx={{ display: "flex", alignItems: "center" }}>
        <Typography
          variant="body1"
          color={getColour(warning.type)}
          sx={{
            color: getColour(warning.type),
            fontWeight: 400,
            paddingRight: 1,
          }}
        >
          {warning.message}
        </Typography>
        <AlertInfo
          stroke={getColour(warning.type)}
          style={{
            fontSize: 16,
          }}
        />
      </Box>
    </Box>
  );
};
